import { Expose } from 'class-transformer';
import { ActivityType } from '../../../enums';

export class LicensableActivityResponseDto {
    @Expose()
    id: string;

    @Expose()
    clientInformationRecordId: string;

    @Expose()
    activityType: ActivityType;

    @Expose()
    isSelected: boolean;
}
